import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import bindAll from 'lodash.bindall'
import LibraryComponent from '../../../components/library/library-no-modal'
import styles from '../../lib/global.css'
import moment from 'moment'

class LessonScheduleList extends React.Component {
  constructor(props) {
    super(props)
    bindAll(this, [
      'handleItemSelect'
    ])
  }

  handleItemSelect(item) {
    this.props.history.push('/lesson?' + item.extensionId)
  }

  render() {
    const items = this.props.lessons.map(item => {
      const date = !!item.time && moment(item.time, 'YYYY-MM-DD hh:mm')
      const locked = date && date > moment()
      return {
        extensionId: `id=${item.id}&clazz_id=${this.props.clazzId}&course_id=${this.props.courseId}`,
        name: item.name,
        rawURL: window.config.staticURL + '/cover/lesson/' + item.id + '.png',
        //iconRawURL: '/static/appstore.png',
        //insetIconURL: item.studying ? require('./studying.png') : undefined,
        featured: true,
        // disabled: false,
        cornerText: locked ? window.L('teach.lesson.locked') : undefined,
        cornerStyle: locked ? { backgroundColor: '#969696' } : undefined,
        description:
          <div onClick={e => {e.stopPropagation()}} className={styles.antRow}>
            {item.time}
          </div>
      }
    })
    return (
      <React.Fragment>
        {/*<img style={{position: 'absolute', zIndex:1, left:'18px', top:'21px'}} src={require('./new.png')} />*/}
        <LibraryComponent
          data={items}
          filterable={false}
          id='CourseLibrary'
          title='课程列表'
          visible={true}
          onItemSelected={this.handleItemSelect}
        />
      </React.Fragment>
    )
  }

}

LessonScheduleList.propTypes = {
  clazzId: PropTypes.number,
  courseId: PropTypes.number,
  lessons: PropTypes.arrayOf(PropTypes.object)
}

export default withRouter(LessonScheduleList)
